import $api from "../http";
import { AxiosResponse } from 'axios'
import { IUser } from "../models/IUser";
import { Option } from "../models/General";
import { Certification, CertificationApplication } from "../models/Certification";

export default class UserService {
  static async fetchUsers(): Promise<AxiosResponse<IUser[]>> {
    return $api.get<IUser[]>("/users")
  }

  static async getLink(): Promise<AxiosResponse<IUser[]>> {
    return $api.get<IUser[]>("/activationLink")
  }

  static async getDegreesOptions(): Promise<AxiosResponse<Option[]>> {
    return $api.get<Option[]>("/degrees")
  }
  
  static async getRankOptions(): Promise<AxiosResponse<Option[]>> {
    return $api.get<Option[]>("/rank")
  }

  static async fetchCertifications(): Promise<AxiosResponse<Certification[]>> {
    return $api.get<Certification[]>("/certifications")
  }

  static async createCertification(data: Certification): Promise<AxiosResponse<Certification[]>> {
    return $api.post<Certification[]>("/cert", { data })
  }

  static async updateCertification(id: string, data: Certification): Promise<AxiosResponse<Certification[]>> {
    return $api.put<Certification[]>("/cert", { certId: id, data })
  }

  static async fetchCertification(id: string): Promise<AxiosResponse<Certification[]>> {
    return $api.get<Certification[]>("/cert/" + id)
  }

  static async applyForCertification(certificationId: number, formData: FormData) {
    return $api.post(`/cert/${certificationId}/apply`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  static async fetchApplications(): Promise<AxiosResponse<CertificationApplication[]>> {
    return $api.get<CertificationApplication[]>("/applications");
  }

  static async fetchUserApplications(userId: string): Promise<AxiosResponse<CertificationApplication[]>> {
    return $api.get<CertificationApplication[]>(`/users/${userId}/applications`);
  }

  static async fetchApplicationById(id: string): Promise<AxiosResponse<any>> {
    return $api.get<any>(`/applications/${id}`);
  }

  static async updateApplicationStatus(id: string, updatedApplication: CertificationApplication): Promise<AxiosResponse<any>> {
    return $api.put<any>(`/applications/${id}/status`, updatedApplication );
  }
}